import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AwsService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-financieras',
  templateUrl: './financieras.component.html',
  styles: []
})
export class FinancierasComponent implements OnInit {

  banks: any[] = [];

  empresaForm = new FormGroup({
    business_name: new FormControl('', [Validators.required]),
    start_date: new FormControl('', [Validators.required]),
    contributor_type: new FormControl('PM', [Validators.required]),
  });

  bancariosForm = new FormGroup({
    bank: new FormControl('', [Validators.required]),
    account_number: new FormControl('', [Validators.required]),
    clabe: new FormControl('', [Validators.required]),
  });

  constructor(
    private awsService: AwsService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.awsService.getBankNumber().subscribe(resp => {
      this.banks = resp;
    });
  }

  send() {
    if (this.empresaForm.invalid) {
      swal2.fire('Atención', 'Completa los datos de la empresa', 'info');
      return;
    }
    if (this.bancariosForm.invalid) {
      swal2.fire('Atención', 'Completa los datos bancarios', 'info');
      return;
    }

    const params = {
      ...this.empresaForm.value,
      ...this.bancariosForm.value
    };

    this.awsService.createFinancialCompany(params).subscribe(resp => {
      swal2.fire('Éxito', 'Empresa financiera registrada correctamente', 'success');
      this.router.navigate(['/panelcontrol/financieras']);
    }, err => {
      console.log(err);
      try {
        swal2.fire('Atención', err.error.error || 'Algo salió mal', 'info');
      } catch {
        swal2.fire('Atención', 'Algo salió mal', 'info');
      }
    });
  }
}
